module.exports = __webpack_public_path__ + "static/process-detail-3a.f7560b71.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/process-details/process-detail-3a.png
// module id = 1491
// module chunks = 214286880276331